<template>
    <div class="auth">
        <div class="auth-controls">
            <div class="wrapper pb-0">
                <a :href="'/'+ lang +'/login'" class="btn btn-back">
                    <span>{{trans.text.forgot.backBtn}}</span>
                </a>
            </div>
        </div>

        <div class="wrapper">
            <div class="auth__in">
                <div class="forgot">
                    <div class="auth-heading">
                        <h2>{{trans.text.forgot.passwordRecovery}}</h2>
                        <p>{{trans.text.forgot.enterEmail}}</p>
                    </div>

                    <div class="auth-form">
                        <div class="inp-group">
                            <label for="recover-mail"
                                   v-if="!EmailError && !EmailSuccess">{{trans.text.forgot.email}}</label>
                            <span class="inp-error__text1" v-if="EmailError">
                                {{EmailError}}
                            </span>
                            <span class="inp-error__text2" v-if="EmailSuccess">
                                {{EmailSuccess}}
                            </span>
                            <input class="inp-style inp-fw" id="recover-mail" name="#" type="email" v-model="email">
                        </div>

                        <button @click="submit()" class="btn btn-green btn-submit">
                            {{trans.text.forgot.recover}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['lang', 'trans'],
        data() {
            return {
                email: '',
                EmailError: '',
                EmailSuccess: ''
            }
        },
        methods: {
            submit() {
                let _this = this
                axios
                    .post(this.$path + '/password/create', {
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        'email': this.email,
                    })
                    .then(response => {
                        localStorage.setItem('email', _this.email);
                        _this.EmailSuccess = response.data.message;
                        _this.EmailError = '';
                        setTimeout(() => {
                            _this.EmailSuccess = "";
                        }, 5000)
                    })
                    .catch(err => {
                        _this.EmailError = err.response.data.errors.reset[0];
                        _this.EmailSuccess = '';
                        setTimeout(() => {
                            _this.EmailError = '';
                        }, 5000)
                    })
            }
        }
    }
</script>
<style scoped>
    .inp-error__text1 {
        font-size: 14px;
        color: #E41B1B;
        display: block;
        margin: 0 0 .5rem;
        line-height: 100%;
    }

    .inp-error__text2 {
        font-size: 14px;
        /*color: #49cc90;*/
        color: #000;
        display: block;
        margin: 0 0 .5rem;
        line-height: 100%;
    }


</style>
